import { useIntl } from 'react-intl';
import { env } from '@/lib/env';

/**
 * App-wide banner shown above the entire layout on the hosted prod-data sandbox
 * (`VITE_SANDBOX=true` at build time). Info-blue so it reads as distinct from the
 * impersonation (danger) and test-workspace (warning) banners. Renders nothing
 * in any other build.
 */
export function SandboxBanner() {
  const intl = useIntl();

  if (!env.sandbox) return null;

  return (
    <div role="status" className="bg-info-700 px-6 py-3 text-center text-sm font-medium text-white">
      {intl.formatMessage(
        { id: 'pages.shell.sandbox-banner.message' },
        { name: (chunks) => <strong className="font-semibold">{chunks}</strong> },
      )}
    </div>
  );
}
